module.exports = __webpack_public_path__ + "media/images/emblems/Wilenr-9a564b9cb9ea820f730a47e46efc4a15.png";